import { analysisList } from "@/mocks/gua";

const catColor: Record<string, string> = {
  音乐: "bg-primary-500 text-background-50",
  综艺: "bg-secondary-500 text-background-50",
  直播: "bg-accent-500 text-background-50",
};

export default function AnalysisGrid() {
  return (
    <section id="analysis" className="scroll-mt-20 bg-background-100/70 py-12 md:py-16">
      <div className="wrap">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
              <i className="ri-file-list-3-line" aria-hidden="true"></i>
              深读专栏 · 前因后果
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              背景解析专栏<span className="text-primary-500">一次讲透</span>
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              不止报发生了什么，更把「为什么走到这一步」拆给你看。配图叙事 + 背景解析，吃瓜也讲证据。
            </p>
          </div>
          <a
            href="#replay"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            更多系列档案
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-6 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {analysisList.map((a) => (
            <article
              key={a.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-52 w-full overflow-hidden">
                <img
                  src={a.image}
                  alt={a.title}
                  title={a.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className={"absolute left-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium " + (catColor[a.cat] ?? "bg-primary-500 text-background-50")}>
                  {a.cat} · 深扒
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                  {a.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{a.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-time-line text-accent-600" aria-hidden="true"></i>
                    {a.read}
                  </span>
                  <a
                    href="#timeline"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
                  >
                    开始阅读
                    <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}